// 悟空数学特色
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';

import { PC, Mobile } from '@wukong/haomao';
import { MyContext } from '../../../../config/context-manager';

import Title from '../Title';
import styles from './style.module.scss';

interface PointItemProps {
  title: string;
  content: string;
  idx: number;
}

const PointItem = ({ title, content, idx }: PointItemProps) => {
  return (
    <p className={styles[`specil-point-${idx}`]}>
      <span className={styles.title}>{title}:</span>
      <span className={styles.titleBr} />
      <span dangerouslySetInnerHTML={{ __html: content }} />
    </p>
  );
};

const PointItemMobile = ({ title, content, idx }: PointItemProps) => {
  return (
    <li className={styles.timeLineItem} key={idx}>
      <div className={styles.bullet}>
        <span className={styles.bulletTop} />
        <span className={styles.bulletBtn} />
      </div>
      <div className={styles.desCon}>
        <span className={styles.title}>{title}:</span>
        <span className={styles.titleBr} />
        <span dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </li>
  );
};

const Specialty = () => {
  const { t } = useTranslation('mathSpecialty');
  const { locale } = useContext(MyContext);

  const PointData: PointItemProps[] = [
    {
      title: t('数学特色-内容-1-标题'),
      content: t('数学特色-内容-1-介绍'),
      idx: 1,
    },
    {
      title: t('数学特色-内容-2-标题'),
      content: t('数学特色-内容-2-介绍'),
      idx: 2,
    },
    {
      title: t('数学特色-内容-3-标题'),
      content: t('数学特色-内容-3-介绍'),
      idx: 3,
    },
    {
      title: t('数学特色-内容-4-标题'),
      content: t('数学特色-内容-4-介绍'),
      idx: 4,
    },
    {
      title: t('数学特色-内容-5-标题'),
      content: t('数学特色-内容-5-介绍'),
      idx: 5,
    },
  ];

  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <Title>{t('数学特色-标题')}</Title>
      <PC>
        <div>
          <div className={styles.bg}>
            <Image src="/images/chinese-math-class/math/specialty/specialty-bg.png" layout="fill" alt="悟空数学特色" />
          </div>
          <div className={styles.specilBox}>
            {PointData.map((item) => (
              <PointItem title={item.title} content={item.content} idx={item.idx} key={item.title} />
            ))}
          </div>
        </div>
      </PC>
      <Mobile>
        <div>
          <div className={styles.mobileContainer}>
            <div className={styles.mobileBg}>
              <Image
                src="/images/chinese-math-class/math/specialty/specialty-m-bg.png"
                layout="fill"
                alt="悟空数学特色"
              />
            </div>
            <div className={styles.timeLineBody}>
              {PointData.map((item) => (
                <PointItemMobile title={item.title} content={item.content} idx={item.idx} key={item.title} />
              ))}
            </div>
          </div>
        </div>
      </Mobile>
    </section>
  );
};

export default Specialty;
